import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'

const ContainerRoot = styled('div')({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
})

const PageContainer = ({ children }) => {
  return <ContainerRoot>{children}</ContainerRoot>
}
PageContainer.propTypes = {
  children: PropTypes.any,
}
export { PageContainer }
